// Shared by Data Extraction and the other study tabs.
export const researcherFontFamily = '"Inter", "Roboto", "Helvetica", "Arial", sans-serif';
export const researcherPageSx = {
  px: { xs: 1, sm: 2 }, py: 2, bgcolor: '#f8f9fb', borderRadius: '0 0 24px 24px',
  fontFamily: researcherFontFamily,
};
export const researcherContentSx = { maxWidth: 1480, width: '100%', mx: 'auto', minWidth: 0 };
export const researcherTitleSx = { fontFamily: researcherFontFamily, fontSize: 22, fontWeight: 700, letterSpacing: '-0.025em', lineHeight: 1.5 };
export const researcherSectionSx = {
  p: { xs: 1.5, sm: 2 }, minWidth: 0, borderRadius: '14px', borderColor: '#e7e8ec',
  fontFamily: researcherFontFamily, boxShadow: '0 3px 16px rgba(24, 32, 48, 0.035)',
};
export const researcherSectionTitleSx = { fontFamily: researcherFontFamily, fontSize: 16, fontWeight: 650, lineHeight: 1.5 };
export const researcherNameSx = { fontFamily: researcherFontFamily, fontSize: 14, fontWeight: 650, lineHeight: 1.5 };
export const researcherMetaSx = { fontFamily: researcherFontFamily, fontSize: 12, lineHeight: 1.5, color: 'text.secondary' };
export const researcherTableHeaderSx = {
  fontFamily: researcherFontFamily, fontSize: 13, fontWeight: 600, lineHeight: 1.5,
  color: 'text.secondary', bgcolor: '#fafafb', borderBottom: '1px solid #e7e8ec', py: 1.5,
};
export const researcherTableContainerSx = { border: '1px solid #e7e8ec', borderRadius: '12px', boxShadow: 'none' };
export const researcherTableSx = {
  fontFamily: researcherFontFamily,
  '& .MuiTableCell-root': { fontFamily: researcherFontFamily, px: 2, py: 1.75 },
  '& .MuiTableCell-head': researcherTableHeaderSx,
  '& .MuiTableCell-body': { fontSize: 14, lineHeight: 1.5, borderColor: '#f0f1f4' },
  '& .MuiTypography-body2': { fontFamily: researcherFontFamily, fontSize: 14, lineHeight: 1.5 },
  '& .MuiTypography-caption': researcherMetaSx,
  '& .MuiTableRow-root:last-child .MuiTableCell-body': { borderBottom: 0 },
  '& .MuiChip-root': { fontFamily: researcherFontFamily, fontWeight: 500, fontSize: 12, borderRadius: '8px' },
  '& .MuiIconButton-root': { width: 32, height: 32, border: '1px solid #e7e8ec', borderRadius: '8px', bgcolor: 'white',
    '&:hover': { bgcolor: '#fcf5f5', borderColor: '#dac0c0' }, '& .MuiSvgIcon-root': { fontSize: 18 } },
};
